import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header'
import { useDarkMode } from '../../rdxsga/hooks/common/useDarkMode';

const FullScreenLayout = (props) => {
    const darkMode = useDarkMode();

    useEffect(() => {
        // //console.log(darkMode);
    }, [darkMode])
    return (
        <div className={`min-h-screen flex items-center justify-center ${darkMode && 'bg-boxdark-2 text-bodydark'}`}>
            {/* <!-- ===== Page Wrapper Start ===== --> */}
            <div className="flex overflow-hidden">
                {/* <!-- ===== Content Area Start ===== --> */}
                <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
                    {/* <!-- ===== Header End ===== --> */}
                    <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                        {props.children}
                    </div>
                    {/* <!-- ===== Main Content End ===== --> */}
                </div>
                {/* <!-- ===== Content Area End ===== --> */}
            </div>
            {/* <!-- ===== Page Wrapper End ===== --> */}
        </div>

    );
};

export default FullScreenLayout;
